
import { Vue, Component, Watch, Prop, Model } from 'vue-property-decorator';
import { Icon, Popup, Picker } from 'vant';

Vue.use(Icon).use(Popup).use(Picker);

@Component
export default class SearchBar extends Vue {
  @Prop({ default: '请输入姓名或作品名称' }) placeholder!: string;
  @Prop({ default: 0 }) searchType!: number; // 0: 图片, 1: 视频
  @Model('userInputChange', { type: String }) keyword!: string;

  userInput = '';
  showTypePicker = false;
  typeColumns = ['图片', '视频'];

  get typeText() {
    return this.searchType === 1 ? '视频' : '图片';
  }

  onTypeConfirm(value: string, index: number) {
    this.$emit('update:searchType', index);
    this.showTypePicker = false;
  }

  @Watch('keyword')
  onParentKeywordChange(val: string) {
    this.userInput = val;
  }

  @Watch('userInput')
  onKeywordChange(newval: string) {
    this.$emit('userInputChange', newval);
    if (!newval.length) {
      this.$emit('clear');
    }
  }

  // get userKeyword() {
  //   return this.keyword;
  // }

  // set userKeyword(val: string) {
  //   console.log('keyword updating', val);
  // }
}
